// extracted by mini-css-extract-plugin
var _1 = "RepositoryConfigInitializer--editorArea";
export { _1 as "editorArea" }
